import{getTokenType}from"../tokens/main.js";

import{isObject,isWeakObject}from"./object.js";


















export const getMissingValue=(value,prop,{missing,classes})=>
missing?handleMissingValue(value,prop,classes).value:value;

export const handleMissingValue=(value,token,classes)=>{
const tokenType=getTokenType(token);
const{isPresent,getDefaultValue}=MISSING_HANDLERS[tokenType.valueType];
const missing=!isPresent(value,classes);
const valueA=missing?getDefaultValue():value;
return{tokenType,missing,value:valueA}
};



const getDefaultObject=()=>({});

const getDefaultArray=()=>[];

export const MISSING_HANDLERS={
objectArray:{
isPresent:(value,classes)=>
isObject(value,classes)||Array.isArray(value),
getDefaultValue:getDefaultObject
},
array:{
isPresent:Array.isArray,
getDefaultValue:getDefaultArray
},
strictObject:{
isPresent:(value,classes)=>isObject(value,classes),
getDefaultValue:getDefaultObject
},
weakObject:{
isPresent:isWeakObject,
getDefaultValue:getDefaultObject
}
};